// Import utils
import { CustomElement } from "../core/CustomElement";

// Components to use
import "../components/html-panel/index";
import { VanillaPagesType } from "../core/types/VanillaPages";
import { selectAnchor } from "../core/utilities";
import OContentModel from "../models/OContentModel";

export interface IntroTextInitOptions {
  anchor: string;
  catName: string;
}

export default class IntroTextController {
  private htmlContent = '<div class="ccc-loading"></div>';
  public introTextComponent: CustomElement = null;

  init(type: VanillaPagesType, options: IntroTextInitOptions): void {
    switch (type) {
      case VanillaPagesType.discussions:
        this._initForDiscussions(options);
        break;
      default:
        throw "Intro Text - Not a valid type";
        break;
    }
  }

  private async _initForDiscussions(options: IntroTextInitOptions) {
    this.introTextComponent = <CustomElement>selectAnchor(options.anchor);
    if (this.introTextComponent) {
      try {
        // load the dom anchor
        this.setLoading(true);
        // load the Leaderboard data, separated by level
        const html = await OContentModel.getIntroTextData(options.catName);
        if (html !== "") {
          this.updateHtmlContent(html);
        }
        this.setLoading(false);
      } catch (err) {
        console.error(err);
        this.introTextComponent.hide();
      }
    } else {
      console.error(`Intro Text - ${options.anchor} element not found in DOM`);
    }
  }

  updateHtmlContent(html: string): void {
    this.htmlContent = html;
    this._updateComponentState();
  }

  setLoading(visible: boolean): void {
    this.introTextComponent.loading = visible;
  }

  protected _updateComponentState(): void {
    this.introTextComponent.setState({
      html: this.htmlContent,
    });
  }
}
